import { render, staticRenderFns } from "./CidadeDigital.vue?vue&type=template&id=42c6ed49&"
import script from "./CidadeDigital.vue?vue&type=script&lang=js&"
export * from "./CidadeDigital.vue?vue&type=script&lang=js&"
import style0 from "./CidadeDigital.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports